import  PhysicalLocation from "domain/physicalLocation";
import { OfferTypeEnum } from "domain/offerType";
import { OfferStatus } from "domain/offerStatus";
import { DeliveryMethod } from "./deliveryMethod";
import { Producer } from "features/settings/producers/producer";
import DeliveryPeriod, { Bid } from "./deliveryPeriod";
import FuturesContract from "./futuresContract";
import { Trader } from "features/settings/traders/trader";
import { AuditUser } from "./auditUser";
import { PaymentOption } from "./paymentOption";
import { OrderDetails } from "./orderDetails";
import Commodity from "./commodity";
import FcmAccount from "features/fcmAccounts/fcmAccount";
import { OrderType } from "./orderType";
import { PositionSetting } from "domain/positionSetting";
import { TasFallbackOption } from "domain/tasFallbackOption";
import Contract from "./contract";
import { MerchantThin } from "domain/merchant";
import { FeeThin } from "./fee";
import { CustomFieldThin } from "./customField";
import { ProducerAccount } from "features/settings/producers/producerAccount";
import { Currency } from "./currency";

export default class Offer {
    id: number;
    merchant: MerchantThin;
    sourceContractId?: number;
    sourceContractDisplayId: string;
    displayId: string;
    type: OfferTypeEnum;
    contractSubType?: string;
    status: OfferStatus;
    deliveryMethod: DeliveryMethod;
    bid: Bid;
    freightFee?: number;
    customerWillSell: boolean;

    orderType: OrderType;
    futuresPrice: number;
    cashPrice: number;
    htaFee?: number;
    fillPrice: number;
    fillTime: Date;
    basis: number;
    isBasisFixed: boolean;
    currentBasis: number;
    quantity: number;
    expirationDate: Date;
    comments: string;
    paymentOption?: PaymentOption;
    deferredPayDate?: string;
    interestStartDate?: string;
    setInterestStartDateOnDateOfFill? : boolean;
    interestRate?: number;
    delayedContract?: Contract;
    deliveryTerms?: string;
    customerContractId?: string;

    producer: Producer;
    customerAccount: ProducerAccount;
    deliveryPeriod: DeliveryPeriod;
    positionSetting: PositionSetting;
    deliveryPeriodStartDate: Date;
    deliveryPeriodEndDate: Date;
    futuresContract: FuturesContract;
    commodity: Commodity;
    location: PhysicalLocation;
    contractLocation: PhysicalLocation;
    region: PhysicalLocation;
    trader: Trader;
    fcmAccount: FcmAccount;
    useMini: boolean;
    numberOfContracts: number;

    relationships: OfferRelationship[];

    order: OrderDetails;
    notifyCustomer: boolean;
    createdBy: AuditUser;
    createdDate: Date;
    lastUpdatedBy: AuditUser;
    lastUpdatedDate: Date;
    buyAtTarget: boolean;
    useManualHedgeConfig: boolean;
    isPriceAtOpenEnabled: boolean;
    fees: FeeThin[];
    rollFee?: number;
    customFields: CustomFieldThin[];

    isPriceLocked?: boolean;
    snapshotPrice?: number;
    snapshotTime?: Date;

    disableErpSync: boolean;
    contractSyncFailureReason?: string;
    currency: Currency;

    tasFallbackOption?: TasFallbackOption;
};

export interface OfferRelationship {
    sourceOfferId: number;
    sourceOfferDisplayId: string;
    targetOfferId: number;
    targetOfferDisplayId: string;
    relationshipType: OfferRelationshipType;
}

export enum OfferRelationshipType {
    Clone = 1
}